interface StubViewProps {
  title: string
  subtitle: string
}

export default function StubView({ title, subtitle }: StubViewProps) {
  return (
    <div className="panel" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
      <div style={{
        width: 40, height: 40, borderRadius: '50%',
        border: '0.5px solid var(--bd-1)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" stroke="var(--t-2)" strokeWidth="1.5">
          <rect x="2" y="2" width="12" height="12" rx="2"/>
          <line x1="5" y1="6" x2="11" y2="6"/>
          <line x1="5" y1="9" x2="8.5" y2="9"/>
        </svg>
      </div>
      <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--t-1)' }}>{title}</div>
      <div style={{ fontSize: 12, color: 'var(--t-2)' }}>{subtitle}</div>
    </div>
  )
}
